import { formatDate, formatDateTime } from "@/common/utils/formatters";
import { ArrowBigRight } from "lucide-react";
import { Link } from "react-router-dom";
import { AnpHistoricalReportData } from "../types/anpHistoricalReport.type";
import Button from "@/common/components/Button";

export class AnpHistoricalReportsTransformer {
  static tableTransformer() {
    return (anpReports: AnpHistoricalReportData[]) => {
      return anpReports.map((anpReport) => {
        return {
          _className: !anpReport.approved_at && 'bg-yellow-op-2',
          initial_date: anpReport.initial_date ? formatDate(new Date(`${anpReport.initial_date} `)) : '',
          end_date: anpReport.end_date ? formatDate(new Date(`${anpReport.end_date} `)) : '',
          approved_at: anpReport.approved_at ? formatDateTime(new Date(anpReport.approved_at)) : '',
          action: (
            <Link to={anpReport.id}>
              <Button name="access_fee_templates_list" variant='link-white' className="w-full" operationKlassToCheckPermission="Admin::Anp::HistoricalReports::Show">
                <ArrowBigRight />
              </Button>
            </Link>
          )
        };
      });
    };
  }
}
